module.exports = __webpack_public_path__ + "img/speech.88df7bd.svg";